import React from "react";
import "./Profile.css";
import { FaUserAlt } from "react-icons/fa";
import { BsFillCameraFill } from "react-icons/bs";
import { AiOutlineLeft } from "react-icons/ai";
import { InputField } from "../../reuseable/InputField";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRef } from "react";
import img from "../../assets/images/images.png";
import secureLocalStorage from "react-secure-storage";
import { useEffect } from "react";
import { Puff } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import Header from "../Components/Header";
export const Profile = () => {
  const [data, setData] = useState({});
  const [image, setImage] = useState("");
  const [imageShow, setImageShow] = useState("");
  const [imageHeader, setimageHeader] = useState("");
  const [contact, setContact] = useState();
  const [checkContact, setCheckContact] = useState();
  const [loading, setLoading] = useState(true);
  const accessToken = secureLocalStorage.getItem("token");

  const refImage = useRef(null);

  const navigate = useNavigate();
  const handleChange = (e) => {
    setContact(e.target.value);
  };

  const handleClick = () => {
    if (!contact) {
      return notify("Contact field empty", "warn");
    }
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken}`);

    var formdata = new FormData();
    formdata.append("contact_number", contact);
    formdata.append("id", data.id);
    if (image) {
      formdata.append("image", image);
    }
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      "https://alhikmahinternational.org/al-asab/public/api/update/profile",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          setimageHeader(imageShow);
          secureLocalStorage.setItem(
            "contact_number",
            result?.data.contact_number
          );
          secureLocalStorage.setItem("image", result?.data.image);
          notify(result.message, "success");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  const notify = (message, type) => {
    type == "success"
      ? toast.success(message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        })
      : toast.error(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
  };
  const handleFile = (e) => {
    const img = refImage.current.files[0];
    setImage(img);
    const obj = URL.createObjectURL(img);
    setImageShow(obj);
  };
  useEffect(() => {
    const img = secureLocalStorage.getItem("image");
    const first_name = secureLocalStorage.getItem("first_name");
    const last_name = secureLocalStorage.getItem("last_name");
    const contact_number = secureLocalStorage.getItem("contact_number");
    const email = secureLocalStorage.getItem("email");
    const employment_number = secureLocalStorage.getItem("employment_number");
    const id = secureLocalStorage.getItem("id");
    setData({
      firstName: first_name,
      lastName: last_name,
      email: email,
      id,
      employment_number,
    });
    setContact(contact_number);
    setCheckContact(contact_number);
    if (img) {
      setImageShow(img);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);
  return (
    <div>
      <ToastContainer />

      {loading && (
        <div className="loaderScreen">
          <Puff
            height={80}
            width={80}
            color="rgba(0, 120, 207, 1)"
            ariaLabel="puff-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}
      <Header imageShow={imageHeader} />
      <div className="inner-image-header">
        <div className=" text-white viewProfile">
          <p>View Profile</p>
        </div>
      </div>
      <div className="container mt-5 pb-5">
        <div className="d-flex gx-3">
          <div
            className={`${
              !image ? "profileAvator" : ""
            } bg-white position-relative`}
          >
            <img
              src={imageShow ? imageShow : img}
              className="profileImageAvator"
            />

            <div className="cameraAvator position-absolute">
              <label
                htmlFor="file-input-0"
                className="cameraAvator position-absolute"
              >
                <input
                  ref={refImage}
                  id="file-input-0"
                  type="file"
                  accept="image/bmp,image/png,image/jpg,image/jpeg"
                  onChange={handleFile}
                  style={{ display: "none" }}
                />
                <BsFillCameraFill fontSize={"25px"} color="grey" />
              </label>
            </div>
          </div>
          <div className=" ms-4 d-flex align-items-end">
            <h5 className="fw-bold" style={{ color: " #5B5B5B" }}>
              Personal Photo
            </h5>
          </div>
        </div>
        <div>
          <div className="row mt-5">
            <div className="col-md-6">
              <div className="inputFieldContainer ">
                <p className="inputLabels">First Name</p>
                <InputField
                  placeholder="First Name"
                  name="firstName"
                  value={data.firstName}
                  className="inputFieldProfile"
                  type="text"
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="inputFieldContainer ">
                <p className="inputLabels">Last Name</p>
                <InputField
                  placeholder="Last Name"
                  name="lastName"
                  value={data.lastName}
                  className="inputFieldProfile"
                  type="text"
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="inputFieldContainer mt-4">
                <p className="inputLabels">Email</p>
                <InputField
                  placeholder="Email"
                  name="email"
                  value={data.email}
                  className="inputFieldProfile"
                  type="email"
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="inputFieldContainer mt-4">
                <p className="inputLabels">Employment Number</p>
                <InputField
                  placeholder="Employment Number"
                  name="employmentNumber"
                  value={data.employment_number}
                  className="inputFieldProfile"
                  type="number"
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="inputFieldContainer mt-4">
                <p className="inputLabels text-dark fw-bold">
                  Contact Number <sup style={{ color: "#E00" }}>*</sup>
                </p>
                <InputField
                  placeholder="Contact Number"
                  name="contactNumber"
                  onChange={handleChange}
                  value={contact}
                  className="inputFieldProfile"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="btnContainer mt-5">
          <button
            className="profileBtnFirst"
            onClick={() => {
              navigate("/home");
            }}
          >
            <span className=" me-2">
              <AiOutlineLeft fontSize={"20px"} fontWeight={"500"} />
            </span>{" "}
            <span className="mt-2">Back</span>
          </button>
          {contact ? (
            <button className="profileBtn" onClick={() => setContact("")}>
              Clear
            </button>
          ) : (
            <button className="profileBtnDisable">Clear</button>
          )}
          {checkContact != contact ? (
            contact ? (
              <button className="profileBtn" onClick={handleClick}>
                Update
              </button>
            ) : (
              <button className="profileBtnDisable">Update</button>
            )
          ) : (
            <button className="profileBtnDisable">Update</button>
          )}
        </div>
      </div>
    </div>
  );
};


